import { render, staticRenderFns } from "./OsobaTvrtkaForma.vue?vue&type=template&id=23cb923c&scoped=true&"
import script from "./OsobaTvrtkaForma.vue?vue&type=script&lang=js&"
export * from "./OsobaTvrtkaForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cb923c",
  null
  
)

export default component.exports